document.addEventListener("DOMContentLoaded", () => {
    const hasModal = document.querySelector('.modal-link');
	if (hasModal) {
        modalInit();
    }
});

function modalInit(){
    // console.log('modalInit()');

    document.querySelectorAll(".modal-link").forEach(function(ml) {
        ml.addEventListener('click', function(e){
            const modalTarget = ml.getAttribute('href').substr(1);
            showModal(modalTarget);
        });
    });

    var modalClosers = document.getElementsByClassName("close-modal");
    for(var i=0; i< modalClosers.length; i++){
        modalClosers[i].addEventListener('click', function(e){
            e.preventDefault();
            showModal("",false);
        });
    }

    document.querySelector('#modals').addEventListener('click', function(e) {//close click interceptor
        if (e.target !== this) return;
        showModal("",false);
    });

    document.body.addEventListener('keydown', function(evt) {
        var isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key === "Escape" || evt.key === "Esc");
        } else {
            isEscape = (evt.keyCode === 27);
        }
        if (isEscape) {
            showModal("",false);
        }
    });
}

function showModal(which, showIt = true){
    // console.log("showModal(" + which + ", " + showIt + ")");

    var $current = document.getElementsByClassName("modal"),
        $modals = document.getElementById("modals"),
        $which = document.getElementById(which + "-modal");

    // hide everything
    for(var i=0; i< $current.length; i++){
        $current[i].style.display = 'none';
    }
    $modals.style.display = 'none';

    //show which
    if(showIt){
        $modals.style.display = 'block';
        $modals.classList.add('animate__animated', 'animate__fadeIn');
        $which.style.display = 'flex';
        $which.classList.add('animate__animated', 'animate__fadeIn');
        // $which.querySelector('.focus').focus();
    }
}
